module.exports = __webpack_public_path__ + "img/ghb.347b6a18.svg";